import { createContext, useContext } from "react";
import { useAuth } from "./AuthContext";

const PermissionContext = createContext({});

export const PermissionProvider = ({ children }) => {
  const { user } = useAuth();

  const hasPermission = (permission, { logic = "AND" } = {}) => {
    if (!user || !user.permissions) return false;

    const requiredPermissions = Array.isArray(permission)
      ? permission
      : [permission];

    if (logic === "OR") {
      return requiredPermissions.some((p) => user.permissions.includes(p));
    }

    return requiredPermissions.every((p) => user.permissions.includes(p));
  };

  return (
    <PermissionContext.Provider value={{ hasPermission }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);

export const Can = ({
  permission,
  logic = "AND",
  children,
  fallback = null,
}) => {
  const { hasPermission } = usePermission();
  return hasPermission(permission, { logic }) ? <>{children}</> : fallback;
};
